<template>
    <div v-if="!isEmpty">
        <component v-if="!isText" :is="is_component" v-bind="$attrs">
            <template v-slot:main="option">
                <slot name="main" v-bind="option"></slot>
            </template>
            <template v-slot:cell="{value}">
                <slot name="cell" :value="value"></slot>
            </template>
        </component>
        <Text v-else><span>{{ $attrs.value }}</span></Text>
        <span v-show="wrapperPost"
              class="absolute flex justify-center items-center w-10 right-0 top-0 bottom-0">{{ wrapperPost }}</span>
    </div>
</template>

<script lang="ts">
import {Options} from 'vue-class-component';
import {Vue} from 'vue-class-component';
import Text from "@/components/Text.vue";

@Options({
    name: 'DynamicCell',
    components: {
        Text
    },
    inheritAttrs: false,
    props: {
        is_component: {
            type: [String, Object],
        },
        wrapperPost: {
            type: String
        },
        wrapperPre: {
            type: String
        }
    }
})

export default class DynamicCell extends Vue {

    is_component!: any;

    get isText() {
        return this.is_component === 'Text'
    }

    get isEmpty() {
        return this.is_component === 'Empty'
    }

}
</script>
